/*
  C4 gallery zoom (17 Oct 2026). Cathy: "if you can add it back that would be good" -- the zoom
  went missing when the C4 gallery replaced Horizon's, and the old one "interfered with the layout".

  So this adds NOTHING to the page flow: a round magnifier button sits INSIDE the main image, in its
  bottom-right corner, styled like the heart and the arrows (moved there 17 Oct at Cathy's request). Clicking it (or clicking/tapping the main image)
  opens a full-screen viewer on top of the page:
    - higher-resolution image (2400px from Shopify's CDN),
    - previous / next arrows, keyboard arrows, swipe on phones (wraps around like the gallery),
    - click or double-tap to zoom in at that spot, move the mouse / drag to look around,
      pinch to zoom on phones,
    - close with X, Esc, or a tap/click outside the image.
  Videos are skipped (they have their own player). Closing leaves the gallery on the image the
  customer was last viewing.

  Self-contained: loaded from snippets/c4-trust-badges.liquid (rendered straight after the gallery
  on every C4 product template). The gallery snippet itself is untouched. The viewer lives on
  <body>, outside the gallery, so the gallery's MutationObserver never sees it.
*/
(function () {
  if (window.__c4Zoom) return;
  window.__c4Zoom = true;

  var CSS = [
    /* Bottom-right corner, styled exactly like the heart and the prev/next arrows as they render on
       the PDP (Cathy, 17 Oct 2026): flat translucent white disc, no border/shadow/blur, ink icon,
       lighter on hover with a small lift. */
    '.c4-gallery__zoom{position:absolute;right:10px;bottom:10px;z-index:5;width:44px;height:44px;display:flex;align-items:center;justify-content:center;padding:0;',
    'border:0;border-radius:50%;background:rgba(255,255,255,.34);color:#101112;cursor:pointer;box-shadow:none;',
    'transition:transform .14s ease,background .14s ease}',
    '.c4-gallery__zoom:hover{transform:translateY(-2px);background:rgba(255,255,255,.14)}',
    '.c4-gallery__zoom:active{transform:translateY(0)}',
    '.c4-gallery__zoom:focus-visible{outline:2px solid #101112;outline-offset:2px}',
    '.c4-gallery__zoom[hidden]{display:none}',
    '.c4-gallery__zoom svg{display:block;pointer-events:none}',
    '@media (hover:none){.c4-gallery__zoom:hover{transform:none}}',
    /* Leave room for the Edit/Clear artwork bar when it shows under the customer's design. */
    '.c4-gallery--artwork .c4-gallery__zoom{bottom:auto;top:62px}',
    '.c4-gallery__main img[data-c4-main]{cursor:zoom-in}',
    'html.c4-lb-open,html.c4-lb-open body{overflow:hidden}',
    '.c4-lb{position:fixed;inset:0;z-index:2147483000;background:rgba(16,17,18,.94);display:flex;align-items:center;justify-content:center;touch-action:none;-webkit-user-select:none;user-select:none}',
    '.c4-lb[hidden]{display:none}',
    '.c4-lb__stage{position:absolute;inset:0;display:flex;align-items:center;justify-content:center;overflow:hidden;padding:56px 64px}',
    '.c4-lb__img{flex:none;display:block;width:auto;height:auto;max-width:100%;max-height:100%;transform-origin:center center;cursor:zoom-in;will-change:transform;border-radius:6px}',
    '.c4-lb.is-zoomed .c4-lb__img{cursor:zoom-out}',
    '.c4-lb.is-anim .c4-lb__img{transition:transform .22s ease}',
    '.c4-lb__btn{position:absolute;z-index:2;width:46px;height:46px;display:flex;align-items:center;justify-content:center;padding:0;border:0;border-radius:50%;background:rgba(255,255,255,.14);color:#fff;cursor:pointer;transition:background .14s ease}',
    '.c4-lb__btn:hover{background:rgba(255,255,255,.28)}',
    '.c4-lb__btn:focus-visible{outline:2px solid #fff;outline-offset:2px}',
    '.c4-lb__btn[hidden]{display:none}',
    '.c4-lb__btn svg{display:block;pointer-events:none}',
    '.c4-lb__close{top:12px;right:12px}',
    '.c4-lb__prev{left:12px;top:50%;margin-top:-23px}',
    '.c4-lb__next{right:12px;top:50%;margin-top:-23px}',
    '.c4-lb__count{position:absolute;z-index:2;left:50%;bottom:14px;transform:translateX(-50%);padding:5px 11px;border-radius:999px;background:rgba(255,255,255,.14);color:#fff;font:600 12.5px/1 system-ui,sans-serif}',
    '.c4-lb__hint{position:absolute;z-index:2;left:16px;top:22px;color:rgba(255,255,255,.7);font:500 12.5px/1 system-ui,sans-serif}',
    /* Phones: same size and inset as the arrows (38px, 8px); the gsm pill moves left of it. */
    '@media (max-width:999px){.c4-gallery__zoom{width:38px;height:38px;right:8px;bottom:8px}.c4-gallery__main:has(.c4-gallery__zoom:not([hidden])) .c4-gallery__pill{right:54px}.c4-lb__stage{padding:56px 8px 48px}.c4-lb__prev,.c4-lb__next{top:auto;bottom:6px;margin-top:0;width:40px;height:40px}.c4-lb__prev{left:10px}.c4-lb__next{right:10px}.c4-lb__hint{display:none}}',
    '@media (prefers-reduced-motion:reduce){.c4-gallery__zoom,.c4-lb.is-anim .c4-lb__img{transition:none}}'
  ].join('');

  var ICON_ZOOM = '<svg viewBox="0 0 24 24" width="19" height="19" aria-hidden="true"><circle cx="10.5" cy="10.5" r="6.2" fill="none" stroke="currentColor" stroke-width="1.8"/><path d="M15.2 15.2 20 20M10.5 7.8v5.4M7.8 10.5h5.4" fill="none" stroke="currentColor" stroke-width="1.8" stroke-linecap="round"/></svg>';
  var ICON_X = '<svg viewBox="0 0 24 24" width="20" height="20" aria-hidden="true"><path d="M6 6l12 12M18 6 6 18" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round"/></svg>';
  var ICON_L = '<svg viewBox="0 0 24 24" width="20" height="20" aria-hidden="true"><path d="M14.5 6 8.5 12l6 6" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/></svg>';
  var ICON_R = '<svg viewBox="0 0 24 24" width="20" height="20" aria-hidden="true"><path d="M9.5 6l6 6-6 6" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/></svg>';

  function init() {
    var root = document.querySelector('[data-c4-gallery]');
    if (!root || root.hasAttribute('data-c4-zoom-ready')) return;
    var stage = root.querySelector('.c4-gallery__main');
    var main = root.querySelector('img[data-c4-main]');
    if (!stage || !main) return;
    root.setAttribute('data-c4-zoom-ready', '');

    var st = document.createElement('style');
    st.textContent = CSS;
    document.head.appendChild(st);

    var btn = document.createElement('button');
    btn.type = 'button';
    btn.className = 'c4-gallery__zoom';
    btn.setAttribute('data-c4-zoom', '');
    btn.setAttribute('aria-label', 'Zoom image');
    btn.title = 'Zoom';
    btn.innerHTML = ICON_ZOOM;
    stage.appendChild(btn);

    function thumbs() { return Array.prototype.slice.call(root.querySelectorAll('[data-c4-thumb]')); }
    function images() { return thumbs().filter(function (t) { return !t.dataset.video && t.dataset.src; }); }
    function active() { return root.querySelector('[data-c4-thumb].is-active'); }
    function big(u) {
      if (!u) return u;
      return /\/cdn\/shop\/|cdn\.shopify\.com/.test(u) ? u.replace(/([?&])width=\d+/, '$1width=2400') : u;
    }

    /* Hide the button while a video is on the stage. Change-only writes, and on our own button, so
       the gallery's observer (which watches 'hidden') settles immediately. */
    function paintBtn() {
      var a = active();
      var hide = !!(a && a.dataset.video) || !images().length;
      if (btn.hidden !== hide) btn.hidden = hide;
    }
    paintBtn();
    new MutationObserver(paintBtn).observe(root, { subtree: true, attributes: true, attributeFilter: ['class'] });

    /* ---- the viewer --------------------------------------------------------------------- */
    var lb = null, img, prevB, nextB, countEl, list = [], idx = 0, lastFocus = null;
    var scale = 1, tx = 0, ty = 0;

    function build() {
      lb = document.createElement('div');
      lb.className = 'c4-lb';
      lb.hidden = true;
      lb.setAttribute('role', 'dialog');
      lb.setAttribute('aria-modal', 'true');
      lb.setAttribute('aria-label', 'Image viewer');
      lb.innerHTML =
        '<div class="c4-lb__stage"><img class="c4-lb__img" alt="" draggable="false"></div>' +
        '<span class="c4-lb__hint">Click the image to zoom</span>' +
        '<button type="button" class="c4-lb__btn c4-lb__close" aria-label="Close">' + ICON_X + '</button>' +
        '<button type="button" class="c4-lb__btn c4-lb__prev" aria-label="Previous image">' + ICON_L + '</button>' +
        '<button type="button" class="c4-lb__btn c4-lb__next" aria-label="Next image">' + ICON_R + '</button>' +
        '<span class="c4-lb__count" aria-live="polite"></span>';
      document.body.appendChild(lb);
      img = lb.querySelector('.c4-lb__img');
      prevB = lb.querySelector('.c4-lb__prev');
      nextB = lb.querySelector('.c4-lb__next');
      countEl = lb.querySelector('.c4-lb__count');

      lb.querySelector('.c4-lb__close').addEventListener('click', close);
      prevB.addEventListener('click', function (e) { e.stopPropagation(); go(-1); });
      nextB.addEventListener('click', function (e) { e.stopPropagation(); go(1); });

      /* Mouse: click the image toggles zoom at that point; while zoomed the image follows the
         pointer. Click outside the image closes. */
      lb.addEventListener('click', function (e) {
        if (e.target.closest('.c4-lb__btn')) return;
        if (suppressClick) { suppressClick = false; return; }
        if (e.target === img) {
          if (lastPointer === 'mouse') toggleZoom(e.clientX, e.clientY);
          return;
        }
        if (scale > 1) { reset(true); return; }
        close();
      });
      lb.addEventListener('mousemove', function (e) {
        if (scale <= 1 || lastPointer !== 'mouse') return;
        followPointer(e.clientX, e.clientY);
      });
      lb.addEventListener('wheel', function (e) { e.preventDefault(); }, { passive: false });

      /* Touch: swipe to change image, drag to pan while zoomed, pinch to zoom, double-tap toggles. */
      var pts = {}, startDist = 0, startScale = 1, sx = 0, sy = 0, ox = 0, oy = 0, moved = 0, lastTap = 0, suppressClick = false, lastPointer = 'mouse';
      function count() { return Object.keys(pts).length; }
      function dist() {
        var k = Object.keys(pts);
        if (k.length < 2) return 0;
        var a = pts[k[0]], b = pts[k[1]];
        return Math.hypot(a.x - b.x, a.y - b.y);
      }
      lb.addEventListener('pointerdown', function (e) {
        lastPointer = e.pointerType;
        if (e.pointerType === 'mouse' || e.target.closest('.c4-lb__btn')) return;
        pts[e.pointerId] = { x: e.clientX, y: e.clientY };
        lb.classList.remove('is-anim');
        if (count() === 2) { startDist = dist(); startScale = scale; }
        else { sx = e.clientX; sy = e.clientY; ox = tx; oy = ty; moved = 0; }
      });
      lb.addEventListener('pointermove', function (e) {
        if (!pts[e.pointerId]) return;
        pts[e.pointerId] = { x: e.clientX, y: e.clientY };
        if (count() >= 2) {
          if (startDist) { scale = Math.max(1, Math.min(4, startScale * dist() / startDist)); if (scale === 1) { tx = 0; ty = 0; } apply(); }
          moved = 99;
          return;
        }
        var dx = e.clientX - sx, dy = e.clientY - sy;
        moved = Math.max(moved, Math.abs(dx), Math.abs(dy));
        if (scale > 1) { tx = ox + dx; ty = oy + dy; apply(); }
        else if (Math.abs(dx) > Math.abs(dy)) { img.style.transform = 'translateX(' + Math.max(-80, Math.min(80, dx * 0.5)) + 'px)'; }
      });
      function up(e) {
        if (!pts[e.pointerId]) return;
        var wasMulti = count() > 1;
        delete pts[e.pointerId];
        if (wasMulti) { if (count() === 1) { var k = Object.keys(pts)[0]; sx = pts[k].x; sy = pts[k].y; ox = tx; oy = ty; } suppressClick = true; return; }
        var dx = e.clientX - sx;
        if (scale <= 1) {
          img.style.transform = '';
          if (moved > 10) { suppressClick = true; if (Math.abs(dx) > 50) go(dx < 0 ? 1 : -1); return; }
        } else if (moved > 10) { suppressClick = true; return; }
        /* A tap. Double-tap on the image toggles zoom; a single tap outside closes (via click). */
        var now = Date.now();
        if (e.target === img) {
          suppressClick = true;
          if (now - lastTap < 320) { toggleZoom(e.clientX, e.clientY); lastTap = 0; }
          else lastTap = now;
        }
      }
      lb.addEventListener('pointerup', up);
      lb.addEventListener('pointercancel', function (e) { delete pts[e.pointerId]; img.style.transform = ''; apply(); });

      document.addEventListener('keydown', function (e) {
        if (!lb || lb.hidden) return;
        if (e.key === 'Escape') { e.preventDefault(); close(); }
        else if (e.key === 'ArrowLeft') { e.preventDefault(); go(-1); }
        else if (e.key === 'ArrowRight') { e.preventDefault(); go(1); }
        else if (e.key === 'Tab') {
          /* Keep focus inside the viewer. */
          var f = Array.prototype.slice.call(lb.querySelectorAll('button:not([hidden])'));
          if (!f.length) return;
          var i = f.indexOf(document.activeElement);
          e.preventDefault();
          f[(i + (e.shiftKey ? -1 : 1) + f.length) % f.length].focus();
        }
      });
      window.addEventListener('resize', function () { if (lb && !lb.hidden) reset(false); });
    }

    function limits() {
      var w = img.offsetWidth, h = img.offsetHeight;
      return { x: Math.max(0, (w * scale - w) / 2), y: Math.max(0, (h * scale - h) / 2) };
    }
    function apply() {
      var l = limits();
      tx = Math.max(-l.x, Math.min(l.x, tx));
      ty = Math.max(-l.y, Math.min(l.y, ty));
      img.style.transform = (scale > 1 || tx || ty) ? 'translate(' + tx + 'px,' + ty + 'px) scale(' + scale + ')' : '';
      lb.classList.toggle('is-zoomed', scale > 1);
    }
    function reset(anim) {
      lb.classList.toggle('is-anim', !!anim);
      scale = 1; tx = 0; ty = 0; apply();
    }
    function centre() {
      var r = img.getBoundingClientRect();
      /* r includes the current transform; recover the untransformed centre. */
      return { x: r.left + r.width / 2 - tx, y: r.top + r.height / 2 - ty };
    }
    function toggleZoom(px, py) {
      lb.classList.add('is-anim');
      if (scale > 1) { reset(true); return; }
      var c = centre();
      scale = 2.5;
      tx = (c.x - px) * (scale - 1);
      ty = (c.y - py) * (scale - 1);
      apply();
    }
    function followPointer(px, py) {
      lb.classList.remove('is-anim');
      var c = centre();
      tx = (c.x - px) * (scale - 1);
      ty = (c.y - py) * (scale - 1);
      apply();
    }

    function show(i) {
      if (!list.length) return;
      idx = (i + list.length) % list.length;
      var t = list[idx];
      reset(false);
      /* Show the 1200px image the gallery already loaded straight away, then swap in the sharp
         2400px one when it arrives -- no blank frame while it downloads. */
      img.src = t.dataset.src;
      var hiSrc = big(t.dataset.src);
      if (hiSrc !== t.dataset.src) {
        var hi = new Image();
        hi.onload = function () { if (list[idx] === t) img.src = hiSrc; };
        hi.src = hiSrc;
      }
      img.alt = t.getAttribute('aria-label') || '';
      var many = list.length > 1;
      prevB.hidden = !many;
      nextB.hidden = !many;
      countEl.hidden = !many;
      countEl.textContent = (idx + 1) + ' / ' + list.length;
    }
    function go(d) { if (list.length > 1) show(idx + d); }

    function open() {
      list = images();
      if (!list.length) return;
      if (!lb) build();
      var a = active();
      var i = list.indexOf(a);
      lastFocus = document.activeElement;
      show(i < 0 ? 0 : i);
      lb.hidden = false;
      document.documentElement.classList.add('c4-lb-open');
      var c = lb.querySelector('.c4-lb__close');
      if (c) try { c.focus({ preventScroll: true }); } catch (e) { c.focus(); }
    }
    function close() {
      if (!lb || lb.hidden) return;
      lb.hidden = true;
      document.documentElement.classList.remove('c4-lb-open');
      reset(false);
      /* Leave the gallery on the image the customer ended on (the gallery's own click path). */
      var t = list[idx];
      if (t && t !== active()) t.click();
      if (lastFocus && lastFocus.focus) try { lastFocus.focus({ preventScroll: true }); } catch (e) {}
    }

    /* Open from the button, or a plain click/tap on the main image (not a swipe -- the gallery's
       own swipe moves the image, so a click that follows a drag is ignored). */
    var downX = null, downY = null;
    stage.addEventListener('pointerdown', function (e) { downX = e.clientX; downY = e.clientY; }, true);
    btn.addEventListener('click', function (e) { e.preventDefault(); e.stopPropagation(); open(); });
    main.addEventListener('click', function (e) {
      if (downX != null && (Math.abs(e.clientX - downX) > 8 || Math.abs(e.clientY - downY) > 8)) return;
      e.stopPropagation();
      open();
    });
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();
})();
